import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnchorMixin } from '../../mixins/components/AnchorMixin';
import CustomPropTypes from '../../util/custom-prop-types';

/**
 * The `Anchor` component renders a basic
 * [HTML anchor element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a).
 * It inherits font styles (i.e. font-size, font-weight, etc) from its parent.
 *
 * @related ['TextButton', 'Text', 'Paragraph']
 * @since 6.0.0
 */
var Anchor = /*#__PURE__*/styled.a.withConfig({
  displayName: "Anchor",
  componentId: "c11n-8-107-0__sc-hn4bge-0"
})(["", ""], AnchorMixin);
Anchor.displayName = 'Anchor';
Anchor.propTypes = {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   *
   * By default, this is a basic `<a>` element, but if you are using this component for an action
   * other than navigation, you should set this to `as="button"`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any,
  /**
   * For use on dark or colored backgrounds.
   */
  inverse: CustomPropTypes.inlineMediaQuery(PropTypes.bool)
};
Anchor.defaultProps = {
  as: 'a',
  inverse: false
};

/** @component */
export { Anchor };